export default "__VITE_ASSET__CI8pHDIa__"